var $ = Object.defineProperty;
var k = (s, e, t) => e in s ? $(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var l = (s, e, t) => k(s, typeof e != "symbol" ? e + "" : e, t);
class j {
  constructor() {
    l(this, "isCDNUrl", (e = "") => e.includes("/cdn/"));
    l(this, "getOptionsPage", (e, t = 25, r = 1) => ({
      ...e,
      per_page: t,
      page: r
    }));
    l(this, "delay", (e) => new Promise((t) => setTimeout(t, e)));
    l(this, "arrayFrom", (e = 0, t) => Array.from({ length: e }, t));
    l(this, "range", (e = 0, t = e) => {
      const r = Math.abs(t - e) || 0, a = e < t ? 1 : -1;
      return this.arrayFrom(r, (n, i) => i * a + e);
    });
    l(this, "asyncMap", async (e, t) => Promise.all(e.map(t)));
    l(this, "flatMap", (e = [], t) => e.map(t).reduce((r, a) => [...r, ...a], []));
    /**
     * @method escapeHTML
     * @param  {string} string text to be parsed
     * @return {string} Text parsed
     */
    l(this, "escapeHTML", function(e) {
      const t = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, r = /[&<>"']/g, a = new RegExp(r.source);
      return e && a.test(e) ? e.replace(r, (n) => t[n]) : e;
    });
  }
  /**
   * @method stringify
   * @param  {object} params
   * @param  {string} prefix
   * @param  {boolean} isArray
   * @return {string} Stringified object
   */
  stringify(e, t, r) {
    const a = [];
    for (const n in e) {
      if (!Object.prototype.hasOwnProperty.call(e, n))
        continue;
      const i = e[n], o = r ? "" : encodeURIComponent(n);
      let g;
      typeof i == "object" ? g = this.stringify(
        i,
        t ? t + encodeURIComponent(`[${o}]`) : o,
        Array.isArray(i)
      ) : g = `${t ? t + encodeURIComponent(`[${o}]`) : o}=${encodeURIComponent(i)}`, a.push(g);
    }
    return a.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {string} regionCode region code, could be eu, us, cn, ap or ca
   * @return {string} The base URL of the region
   */
  getRegionURL(e) {
    const t = "api.storyblok.com", r = "api-us.storyblok.com", a = "app.storyblokchina.cn", n = "api-ap.storyblok.com", i = "api-ca.storyblok.com";
    switch (e) {
      case "us":
        return r;
      case "cn":
        return a;
      case "ap":
        return n;
      case "ca":
        return i;
      default:
        return t;
    }
  }
}
const T = function(s, e) {
  const t = {};
  for (const r in s) {
    const a = s[r];
    e.includes(r) && a !== null && (t[r] = a);
  }
  return t;
}, w = (s) => s === "email", I = () => ({
  singleTag: "hr"
}), R = () => ({
  tag: "blockquote"
}), x = () => ({
  tag: "ul"
}), _ = (s) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: s.attrs
    }
  ]
}), A = () => ({
  singleTag: "br"
}), U = (s) => ({
  tag: `h${s.attrs.level}`
}), M = (s) => ({
  singleTag: [
    {
      tag: "img",
      attrs: T(s.attrs, ["src", "alt", "title"])
    }
  ]
}), z = () => ({
  tag: "li"
}), E = () => ({
  tag: "ol"
}), H = () => ({
  tag: "p"
}), P = (s) => ({
  tag: [
    {
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": s.attrs.name,
        emoji: s.attrs.emoji
      }
    }
  ]
}), S = () => ({
  tag: "b"
}), C = () => ({
  tag: "s"
}), L = () => ({
  tag: "u"
}), q = () => ({
  tag: "strong"
}), O = () => ({
  tag: "code"
}), N = () => ({
  tag: "i"
}), F = (s) => {
  if (!s.attrs)
    return {
      tag: ""
    };
  const e = new j().escapeHTML, t = { ...s.attrs }, { linktype: r = "url" } = s.attrs;
  if (delete t.linktype, t.href && (t.href = e(s.attrs.href || "")), w(r) && (t.href = `mailto:${t.href}`), t.anchor && (t.href = `${t.href}#${t.anchor}`, delete t.anchor), t.custom) {
    for (const a in t.custom)
      t[a] = t.custom[a];
    delete t.custom;
  }
  return {
    tag: [
      {
        tag: "a",
        attrs: t
      }
    ]
  };
}, W = (s) => ({
  tag: [
    {
      tag: "span",
      attrs: s.attrs
    }
  ]
}), D = () => ({
  tag: "sub"
}), v = () => ({
  tag: "sup"
}), B = (s) => ({
  tag: [
    {
      tag: "span",
      attrs: s.attrs
    }
  ]
}), G = (s) => {
  var t;
  return (t = s.attrs) != null && t.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `background-color:${s.attrs.color};`
        }
      }
    ]
  } : {
    tag: ""
  };
}, J = (s) => {
  var t;
  return (t = s.attrs) != null && t.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `color:${s.attrs.color}`
        }
      }
    ]
  } : {
    tag: ""
  };
}, K = {
  nodes: {
    horizontal_rule: I,
    blockquote: R,
    bullet_list: x,
    code_block: _,
    hard_break: A,
    heading: U,
    image: M,
    list_item: z,
    ordered_list: E,
    paragraph: H,
    emoji: P
  },
  marks: {
    bold: S,
    strike: C,
    underline: L,
    strong: q,
    code: O,
    italic: N,
    link: F,
    styled: W,
    subscript: D,
    superscript: v,
    anchor: B,
    highlight: G,
    textStyle: J
  }
}, Q = function(s) {
  const e = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, t = /[&<>"']/g, r = new RegExp(t.source);
  return s && r.test(s) ? s.replace(t, (a) => e[a]) : s;
};
let b = !1;
class X {
  constructor(e) {
    l(this, "marks");
    l(this, "nodes");
    e || (e = K), this.marks = e.marks || [], this.nodes = e.nodes || [];
  }
  addNode(e, t) {
    this.nodes[e] = t;
  }
  addMark(e, t) {
    this.marks[e] = t;
  }
  render(e, t = { optimizeImages: !1 }, r = !0) {
    if (!b && r && (console.warn(
      "Warning ⚠️: The RichTextResolver class is deprecated and will be removed in the next major release. Please use the `@storyblok/richtext` package instead. https://github.com/storyblok/richtext/"
    ), b = !0), e && e.content && Array.isArray(e.content)) {
      let a = "";
      return e.content.forEach((n) => {
        a += this.renderNode(n);
      }), t.optimizeImages ? this.optimizeImages(a, t.optimizeImages) : a;
    }
    return console.warn(
      `The render method must receive an Object with a "content" field.
      The "content" field must be an array of nodes as the type ISbRichtext.
      ISbRichtext:
        content?: ISbRichtext[]
        marks?: ISbRichtext[]
        attrs?: any
        text?: string
        type: string
        
        Example:
        {
          content: [
            {
              content: [
                {
                  text: 'Hello World',
                  type: 'text'
                }
              ],
              type: 'paragraph'
            }
          ],
          type: 'doc'
        }`
    ), "";
  }
  optimizeImages(e, t) {
    let r = 0, a = 0, n = "", i = "";
    typeof t != "boolean" && (typeof t.width == "number" && t.width > 0 && (n += `width="${t.width}" `, r = t.width), typeof t.height == "number" && t.height > 0 && (n += `height="${t.height}" `, a = t.height), (t.loading === "lazy" || t.loading === "eager") && (n += `loading="${t.loading}" `), typeof t.class == "string" && t.class.length > 0 && (n += `class="${t.class}" `), t.filters && (typeof t.filters.blur == "number" && t.filters.blur >= 0 && t.filters.blur <= 100 && (i += `:blur(${t.filters.blur})`), typeof t.filters.brightness == "number" && t.filters.brightness >= -100 && t.filters.brightness <= 100 && (i += `:brightness(${t.filters.brightness})`), t.filters.fill && (t.filters.fill.match(/[0-9A-F]{6}/gi) || t.filters.fill === "transparent") && (i += `:fill(${t.filters.fill})`), t.filters.format && ["webp", "png", "jpeg"].includes(t.filters.format) && (i += `:format(${t.filters.format})`), typeof t.filters.grayscale == "boolean" && t.filters.grayscale && (i += ":grayscale()"), typeof t.filters.quality == "number" && t.filters.quality >= 0 && t.filters.quality <= 100 && (i += `:quality(${t.filters.quality})`), t.filters.rotate && [90, 180, 270].includes(t.filters.rotate) && (i += `:rotate(${t.filters.rotate})`), i.length > 0 && (i = `/filters${i}`))), n.length > 0 && (e = e.replace(/<img/g, `<img ${n.trim()}`));
    const o = r > 0 || a > 0 || i.length > 0 ? `${r}x${a}${i}` : "";
    return e = e.replace(
      /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g,
      `a.storyblok.com/f/$1/$2.$3/m/${o}`
    ), typeof t != "boolean" && (t.sizes || t.srcset) && (e = e.replace(/<img.*?src=["|'](.*?)["|']/g, (g) => {
      var d, p;
      const f = g.match(
        /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g
      );
      if (f && f.length > 0) {
        const u = {
          srcset: (d = t.srcset) == null ? void 0 : d.map((c) => {
            if (typeof c == "number")
              return `//${f}/m/${c}x0${i} ${c}w`;
            if (typeof c == "object" && c.length === 2) {
              let m = 0, y = 0;
              return typeof c[0] == "number" && (m = c[0]), typeof c[1] == "number" && (y = c[1]), `//${f}/m/${m}x${y}${i} ${m}w`;
            }
            return "";
          }).join(", "),
          sizes: (p = t.sizes) == null ? void 0 : p.map((c) => c).join(", ")
        };
        let h = "";
        return u.srcset && (h += `srcset="${u.srcset}" `), u.sizes && (h += `sizes="${u.sizes}" `), g.replace(/<img/g, `<img ${h.trim()}`);
      }
      return g;
    })), e;
  }
  renderNode(e) {
    const t = [];
    e.marks && e.marks.forEach((a) => {
      const n = this.getMatchingMark(a);
      n && n.tag !== "" && t.push(this.renderOpeningTag(n.tag));
    });
    const r = this.getMatchingNode(e);
    return r && r.tag && t.push(this.renderOpeningTag(r.tag)), e.content ? e.content.forEach((a) => {
      t.push(this.renderNode(a));
    }) : e.text ? t.push(Q(e.text)) : r && r.singleTag ? t.push(this.renderTag(r.singleTag, " /")) : r && r.html ? t.push(r.html) : e.type === "emoji" && t.push(this.renderEmoji(e)), r && r.tag && t.push(this.renderClosingTag(r.tag)), e.marks && e.marks.slice(0).reverse().forEach((a) => {
      const n = this.getMatchingMark(a);
      n && n.tag !== "" && t.push(this.renderClosingTag(n.tag));
    }), t.join("");
  }
  renderTag(e, t) {
    return e.constructor === String ? `<${e}${t}>` : e.map((a) => {
      if (a.constructor === String)
        return `<${a}${t}>`;
      {
        let n = `<${a.tag}`;
        if (a.attrs) {
          for (const i in a.attrs)
            if (Object.prototype.hasOwnProperty.call(a.attrs, i)) {
              const o = a.attrs[i];
              o !== null && (n += ` ${i}="${o}"`);
            }
        }
        return `${n}${t}>`;
      }
    }).join("");
  }
  renderOpeningTag(e) {
    return this.renderTag(e, "");
  }
  renderClosingTag(e) {
    return e.constructor === String ? `</${e}>` : e.slice(0).reverse().map((r) => r.constructor === String ? `</${r}>` : `</${r.tag}>`).join("");
  }
  getMatchingNode(e) {
    const t = this.nodes[e.type];
    if (typeof t == "function")
      return t(e);
  }
  getMatchingMark(e) {
    const t = this.marks[e.type];
    if (typeof t == "function")
      return t(e);
  }
  renderEmoji(e) {
    if (e.attrs.emoji)
      return e.attrs.emoji;
    const t = [
      {
        tag: "img",
        attrs: {
          src: e.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }
    ];
    return this.renderTag(t, " /");
  }
}
export {
  X as default
};
